import {
  PayoutDestinationType,
  PreferredPayoutSpeed
} from "@wingspanhq/wingspan-api-sdk";
import { WSMutationConfig } from "@ws-react-query";
import { payoutsApi } from "@api";
import { queriesPayouts } from "@query";
import { selectorOwnPayoutSettings } from "@selectors/selectorOwnPayoutSettings";
import { useWSMutation } from "../../../../query/helpers";
import { PayoutMethodType } from "../../../../shared/types/payments";
import { WSServiceError } from "../../../../utils/serviceHelper";

export const useMutationSubmit = (
  config?: WSMutationConfig<{ payoutMethodType: PayoutMethodType }>
) => {
  return useWSMutation<
    { payoutMethodType: PayoutMethodType },
    WSServiceError,
    { payoutMethodType?: PayoutMethodType }
  >(
    async ({ payoutMethodType }) => {
      if (!payoutMethodType) throw new Error("No payout method provided");

      const payoutSettingsList =
        await queriesPayouts.listPayoutSettings.fetchQueryData();
      const payoutSettingsId =
        selectorOwnPayoutSettings(payoutSettingsList)?.id;

      if (payoutSettingsId) {
        if (payoutMethodType === PayoutMethodType.Wallet) {
          await payoutsApi.updatePayoutSettings({
            payoutSettingsId,
            payoutSettingsUpdate: {
              preferredPayoutSpeed: PreferredPayoutSpeed.STANDARD
            }
          });
        } else if (payoutMethodType === PayoutMethodType.GiftCard) {
          await payoutsApi.updatePayoutSettings({
            payoutSettingsId,
            payoutSettingsUpdate: {
              preferredPayoutSpeed: PreferredPayoutSpeed.STANDARD,
              standardDestination: {
                type: PayoutDestinationType.GIFT_CARD,
                id: "WeGift"
              }
            }
          });
        }
      }

      return { payoutMethodType };
    },
    {
      dependencies: [
        queriesPayouts.listPayoutSettings.queryKeyBase,
        queriesPayouts.getPayoutSettings.queryKeyBase
      ],
      ...config
    }
  );
};
